import { useEffect, useState } from "react";
import { Trash2 } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

const EMPTY = { name: "", phone: "", line1: "", line2: "", city: "", state: "", pincode: "", is_default: false };

export default function Addresses() {
  const [list, setList] = useState([]);
  const [form, setForm] = useState(EMPTY);
  const [adding, setAdding] = useState(false);
  const load = () => api.get("/addresses").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    for (const k of ["name", "phone", "line1", "city", "state", "pincode"]) if (!form[k]) { toast.error("Complete all fields"); return; }
    await api.post("/addresses", form); setForm(EMPTY); setAdding(false); load(); toast.success("Address saved");
  };
  const del = async (id) => { await api.delete(`/addresses/${id}`); load(); };

  return (
    <div>
      <div className="mb-6 flex items-center justify-between">
        <h1 className="text-2xl font-extrabold text-midnight">Saved Addresses</h1>
        <button onClick={() => setAdding(!adding)} data-testid="add-address-btn" className="rounded-full bg-midnight px-5 py-2.5 text-sm font-bold text-white">{adding ? "Cancel" : "+ Add Address"}</button>
      </div>
      {adding && (
        <div className="mb-6 grid sm:grid-cols-2 gap-3 rounded-3xl border border-border p-6">
          {[["name", "Full name"], ["phone", "Phone"], ["line1", "Address line 1"], ["line2", "Address line 2 (optional)"], ["city", "City"], ["state", "State"], ["pincode", "Pincode"]].map(([k, ph]) => (
            <input key={k} value={form[k]} onChange={(e) => setForm((f) => ({ ...f, [k]: e.target.value }))} placeholder={ph} data-testid={`addr-field-${k}`} className="rounded-xl border border-border px-4 py-3 text-sm outline-none focus:border-gold" />
          ))}
          <label className="flex items-center gap-2 text-sm sm:col-span-2"><input type="checkbox" checked={form.is_default} onChange={(e) => setForm((f) => ({ ...f, is_default: e.target.checked }))} className="accent-gold" /> Set as default</label>
          <button onClick={save} data-testid="save-addr-btn" className="rounded-full bg-gold py-3 font-bold text-midnight sm:col-span-2">Save Address</button>
        </div>
      )}
      {list.length === 0 ? <p className="text-muted-foreground">No saved addresses yet.</p> : (
        <div className="grid sm:grid-cols-2 gap-4">
          {list.map((a) => (
            <div key={a.id} className="rounded-3xl border border-border p-5">
              <div className="flex justify-between">
                <p className="font-bold text-midnight">{a.name} {a.is_default && <span className="ml-1 rounded-full bg-gold/15 px-2 py-0.5 text-[10px] font-bold text-gold-dark">Default</span>}</p>
                <button onClick={() => del(a.id)} className="text-red-600"><Trash2 className="h-4 w-4" /></button>
              </div>
              <p className="mt-1 text-sm text-muted-foreground">{a.phone}</p>
              <p className="text-sm text-muted-foreground">{a.line1}, {a.line2 && a.line2 + ", "}{a.city}, {a.state} - {a.pincode}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
